import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=35dc1cd4&scoped=true&"
import script from "./tooltip.vue?vue&type=script&lang=js&"
export * from "./tooltip.vue?vue&type=script&lang=js&"
import style0 from "./tooltip.vue?vue&type=style&index=0&id=35dc1cd4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc1cd4",
  null
  
)

export default component.exports